import React, { useState } from 'react'
import { FaAngleLeft, FaAngleRight, FaRegWindowMinimize } from 'react-icons/fa'
import styled from 'styled-components'
import { v4 as uuidv4 } from 'uuid'
import { durationFormat } from 'variables/functions'
import { PUBLIC_LINK_BASE, LINK_BASE } from 'variables/general'
import { packageCategories } from 'variables/general'

const MarketplaceCarousel = (props) => {
  // TWO DUPLICATE IMAGE ARRAYS TO ALLOW FOR DEFAULT FORWARD AND BACKWARDS CAROUSEL TRAVERSING

  const itemRow1 = props.items.map((item) => (
    <ImageContainer
      key={uuidv4()}
      href={
        props.location === 'marketplace-portfolio'
          ? `${LINK_BASE}/marketplace-package/${item.identifier}`
          : `${PUBLIC_LINK_BASE(item.photographer)}/package/${item.identifier}`
      }
    >
      <Image
        src={item.images[0].thumbnail}
        alt={`${item.title} Photo by ${item.photographer.companyName} in ${
          packageCategories[item.category].name
        } Package, ${item.location.name}`}
      />
    </ImageContainer>
  ))

  const itemRow2 = props.items.map((item) => (
    <ImageContainer
      key={uuidv4()}
      href={
        props.location === 'marketplace-portfolio'
          ? `${LINK_BASE}/marketplace-package/${item.identifier}`
          : `${PUBLIC_LINK_BASE(item.photographer)}/package/${item.identifier}`
      }
    >
      <Image
        src={item.images[0].thumbnail}
        alt={`${item.title} Photo by ${item.photographer.companyName} in ${
          packageCategories[item.category].name
        } Package, ${item.location.name}`}
      />
    </ImageContainer>
  ))

  const [itemIndex, setitemIndex] = useState(itemRow1.length)
  const [itemArray] = useState(itemRow1.concat(itemRow2))
  const [transitionEnabled, setTransitionEnabled] = useState(false)

  // LOGIC FOR SHOWING WHAT TRAVERSE INDICATOR SHOULD HAVE ITS OPACITY SET TO ONE
  const TraverseIndicators = props.items.map((item, index) => {
    let shown = 'false'
    if (itemIndex + 1 > itemRow1.length && itemIndex - itemRow1.length === index) {
      shown = 'true'
    } else if (itemIndex < itemRow1.length && itemIndex === index) {
      shown = 'true'
    }

    return <TraverseIndicator key={item.identifier} shown={shown} />
  })

  // SET TIMEOUTS TO ONLY ENABLE THE CSS TRANSITION FEATURE FOR ONCLICK HANDLER USE
  const previousHandler = () => {
    setTransitionEnabled(true)
    setTimeout(() => setitemIndex(itemIndex - 1), 5)
    setTimeout(() => setTransitionEnabled(false), 500)
  }

  const nextHandler = async () => {
    setTransitionEnabled(true)
    setTimeout(() => setitemIndex(itemIndex + 1), 5)
    setTimeout(() => setTransitionEnabled(false), 500)
  }

  let leftOffset = `${itemIndex * -45}em`
  let doubledItemArray = props.items.concat(props.items)
  let activePackage = doubledItemArray[itemIndex]

  return (
    <Container fontColor={props.fontColor}>
      <ViewPort>
        {itemIndex !== 0 && itemArray.length > 2 && <LeftIndicator onClick={previousHandler} />}
        {itemIndex !== itemArray.length - 1 && itemArray.length > 2 && (
          <RightIndicator onClick={nextHandler} />
        )}
        <FlexRow>{itemArray.length > 2 && TraverseIndicators}</FlexRow>
        <ImageRowContainer leftOffset={leftOffset} transitionEnabled={transitionEnabled}>
          {itemArray}
        </ImageRowContainer>
      </ViewPort>
      {activePackage && (
        <Div
          href={
            props.location === 'marketplace-portfolio'
              ? `${LINK_BASE}/marketplace-package/${activePackage.identifier}`
              : `${PUBLIC_LINK_BASE(activePackage.photographer)}/package/${activePackage.identifier}`
          }
          rel="noopener"
          target="_blank"
        >
          <Row>
            <Title>{activePackage.title}</Title>
            <Info font={props.secondaryFont ? props.secondaryFont : props.displayFont}>More Info</Info>
          </Row>
          <H2 font={props.secondaryFont ? props.secondaryFont : props.displayFont}>
            {durationFormat(activePackage.hoursOfCoverage)} Session
          </H2>
          <H1 font={props.secondaryFont ? props.secondaryFont : props.displayFont}>
            {activePackage.startingAt ? 'Starting at ' : ''}
            {activePackage?.photographer?.overrideCurrencySymbol ?? activePackage.photographer.currencySymbol}
            {~~activePackage.price}{' '}
            <small>
              {(activePackage?.photographer?.overrideCurrencyCode ||
                activePackage.photographer.currencyCode) &&
                (activePackage?.photographer?.overrideCurrencyCode?.toUpperCase() ??
                  activePackage.photographer.currencyCode.toUpperCase())}
            </small>
          </H1>
        </Div>
      )}
    </Container>
  )
}

export default MarketplaceCarousel

const Container = styled.div`
  position: relative;
  width: 45em;
  height: auto;
  @media (max-width: 500px) {
    width: 47em;
  }
  color: ${(props) => (props.fontColor ? props.fontColor : 'var(--black)')};
`

const ViewPort = styled.div`
  position: relative;
  width: 45em;
  height: 30em;
  overflow: hidden;
`

const ImageRowContainer = styled.div`
  position: absolute;
  display: flex;
  left: ${(props) => (props.leftOffset ? props.leftOffset : 'initial')};
  transition: ${(props) => (props.transitionEnabled ? 'left 0.4s ease-in-out' : 'none')};
`

const Image = styled.img`
  width: 45em;
  height: 30em;
  object-fit: cover;
  cursor: pointer;
  margin: 0 0 1em 0;
  @media (max-width: 500px) {
    width: 47em;
    height: calc(47 / 45 * 30em);
  }
`

const ImageContainer = styled.a`
  position: relative;
  height: 35em;
  width: 45em;
`
const LeftIndicator = styled(FaAngleLeft)`
  position: absolute;
  box-sizing: content-box;
  cursor: pointer;
  font-size: 5em;
  top: 50%;
  left: 5%;
  transform: translate(-50%, -50%);
  color: white;
  border-radius: 999em;
  border: 2em solid transparent;
  z-index: 1;
  :hover {
    opacity: 0.5;
  }
`
const RightIndicator = styled(FaAngleRight)`
  position: absolute;
  box-sizing: content-box;
  cursor: pointer;
  color: white;
  font-size: 5em;
  top: 50%;
  left: 95%;
  transform: translate(-50%, -50%);
  border-radius: 999em;
  border: 2em solid transparent;
  z-index: 1;
  :hover {
    opacity: 0.5;
  }
`
const TraverseIndicator = styled(FaRegWindowMinimize)`
  color: white;
  font-size: 4em;
  margin: 0.1em;
  opacity: ${(props) => (props.shown === 'true' ? '1' : '0.4')};
`

const FlexRow = styled.div`
  display: flex;
  position: absolute;
  top: 80%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`

const H1 = styled.div`
  font-weight: 600;
  font-size: 2em;
  font-family: ${(props) => !!props.font && props.font};
  cursor: pointer;
  margin: 0.4em 0 0 0;
  @media (max-width: 900px) and (min-width: 500.02px) {
    font-size: 1.8em;
  }
  @media (max-width: 500px) {
    font-size: 2.5em;
  }
`

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Title = styled(H1)`
  max-width: 80%;
  margin: 10px 0 0 0;
  @media (max-width: 900px) and (min-width: 500px) {
    font-size: 1.8em;
  }
  @media (max-width: 500px) {
    font-size: 2.5em;
  }
`

const Info = styled.div`
  font-size: 1.6em;
  font-family: ${(props) => !!props.font && props.font};
  margin: 13px 0 0 0;
  text-decoration: underline;
  @media (max-width: 900px) and (min-width: 500px) {
    font-size: 1.4em;
  }
  @media (max-width: 500px) {
    font-size: 2em;
  }
`

const H2 = styled.h1`
  font-size: 1.6em;
  font-weight: 450;
  text-align: left;
  cursor: pointer;
  font-family: ${(props) => !!props.font && props.font};
  margin: 0.4em 0 0 0;
  @media (max-width: 900px) and (min-width: 500px) {
    font-size: 1.8em;
  }
  @media (max-width: 500px) {
    font-size: 2.2em;
  }
`

const Div = styled.a`
  margin: 1em 0 0 0;
`

ImageRowContainer.displayName = 'ImageRowContainer'
